<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

import { slugify } from "@/helpers/slugify";
import user from "@/api/user";

export default {
  name: 'App',
  components: {},
  data: () => {
    return {
      tries: 0,
      initLocation: ""
    }
  },
  watch: {
    '$route.params.companySlug': {
      handler() {
        if (this.$route.name === 'Authenticate') {
          return
        }
        if (this.$route.params.companySlug) {
          console.log('Company slug 1', this.$route.params, this.$store.getters)
          let companySlug = this.$store.getters.company.slug || slugify(this.$store.getters.company.name)
          if (companySlug === this.$route.params.companySlug) {
            this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
            return true
          }
          //check in userCompanies
          let company = this.companies.find(company => {
            let slug = company.slug || slugify(company.name)
            return slug === this.$route.params.companySlug
          })
          if (company) {
            this.$store.dispatch('setUserCompany', company);
            this.$store.dispatch('getUserInfo', this.$store.getters.selectedCompanyId)
            return true;
          }

          this.$store.dispatch('getCapgeminiCompany', {
            query: { _slug: this.$route.params.companySlug.replaceAll('-', '.') }, urlSlug: this.$route.params.companySlug, cb: (data) => {
              console.log('Data', data, this.$route.params)
              if (!data.isCapgeminiOpenAccess) {
                console.log('Data condition 1', data)
                this.$store.dispatch('getPublicCompany', {
                  query: { _slug: this.$route.params.companySlug.replaceAll('-', '.') }, cb: () => {
                    user.createPublicUser({
                      idCompany: this.$store.getters.publicCompany.idCompany
                    }, (response) => {
                      if (response.token) {
                        this.$store.dispatch('setToken', response.token)
                        this.$store.dispatch('setPublicUser', true)
                      }
                      this.$store.dispatch('setUserCompany', this.$store.getters.publicCompany)
                      this.$store.dispatch('getUserInfo', this.$store.getters.publicCompany.idCompany)
                    })
                  }
                });
              } else {
               const ssoKey = `sso-attempt-${data.idCompany}`;
               if (sessionStorage.getItem(ssoKey) && this.$store.getters.token) {
                  console.log('Data condition 2', data);
                  this.$store.dispatch('getPublicCompany', {
                    query: { _slug: this.$route.params.companySlug.replaceAll('-', '.') }, cb: () => {
                      sessionStorage.removeItem(ssoKey);
                      this.$store.dispatch('setUserCompany', this.$store.getters.publicCompany)
                      this.$store.dispatch('getUserInfo', this.$store.getters.publicCompany.idCompany)
                    }
                  });
                } else {
                  sessionStorage.setItem(ssoKey, '1');
                  location.href = `https://signin.capgemini.com/as/authorization.oauth2?response_type=code&client_id=capgeminiengage&redirect_uri=https%3A%2F%2Fengage.edge.capgemini.com%2Fauthenticate&state=opencapgemini-${data.idCompany}&scope=openid`
                }
              }
            }
          });
          return true;
        } else if (this.$route.name !== 'SelectCompany' && this.$store.getters.company && this.$store.getters.company.slug && this.$store.getters.token) {
          console.log('Company slug 2', this.$route, this.$store.getters)
          if (this.tries > 2) {
            this.$store.dispatch('setToken', null)
            this.$router.push({ name: 'Login' })
          }
          this.tries = this.tries + 1
          this.$router.push({ name: 'Home', params: { companySlug: this.$store.getters.company.slug } })
        } else if (this.$store.getters.token) {
          this.$router.push('/company-select')
        } else {
          this.$router.push({ name: 'Login' })
        }
      },
      immediate: true
    }
  },
  computed: {
    companies() {
      return this.$store.getters.userCompanies
    },
  },
  created() {
    if (['Login', 'SelectCompany', 'Authenticate'].includes(this.$route.name)) {
      return
    }
    this.$store.dispatch('setInitLocation', this.$route.path)
    this.$store.dispatch('getPublicCompanies')
  },
  mounted() {
    // this.$nextTick(() => {
    //   if(!this.isLoggedIn && this.$route.name !== 'Login') {
    //     this.$router.push('/login')
    //   }
    // })
  },
  // computed: {
  //   isLoggedIn() {
  //     return this.$store.getters.isLoggedIn
  //   }
  // }
}
// https://engage.edge.capgemini.com/web/engage-app/
</script>
